import { render } from "./SampleModal.vue?vue&type=template&id=bb0d6b58&scoped=true"
import script from "./SampleModal.vue?vue&type=script&lang=js"
export * from "./SampleModal.vue?vue&type=script&lang=js"

import "./SampleModal.vue?vue&type=style&index=0&id=bb0d6b58&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0d6b58"]])

export default __exports__